import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e317a4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inputLine" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = ["id", "onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "msg" }
const _hoisted_7 = { class: "date" }

import { ref } from 'vue'
import 'ant-design-vue/lib/input/style/css'
import router from '@/router'
import { message } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const inputKey = ref('')
const onSearch = () => {
    if (!inputKey.value) {
        searchList.value = dataList
        return
    }
    const res = dataList.filter((i) => i.name?.includes(inputKey.value) || i.msg?.includes(inputKey.value))
    if (!res.length) {
        message.info('未查询到该内容！')
        return
    }
    searchList.value = res
}

const navToDetail = (i) => {
    i.routeName
        ? router.push({
              name: i.routeName,
          })
        : window.open(i.url)
}

const searchList = ref<typeof dataList>([])

const dataList = [
    // {
    //     name: '外籍教练员评选',
    //     msg: '外籍教练员评选',
    //     date: '2021/01/24',
    //     pic: 'foreign-coach',
    //     routeName: 'foreign-coach',
    // },
    {
        name: 'WCBA球员三人篮球考察解析',
        msg: 'WCBA球员三人篮球考察解析',
        date: '2021/12/24',
        pic: 'wcba-three-player-comment',
        routeName: 'wcba-three-player-comment',
    },
    {
        name: '女篮世界杯预选赛参考名单解析',
        msg: '中国女篮 尼日利亚女篮 马里女篮',
        date: '2021/12/22',
        pic: 'women-world-cup-player-comment',
        routeName: 'women-world-cup-player-comment',
    },
    {
        name: '21-22赛季CBA联赛第一阶段数据总结',
        msg: '第一阶段数据总结',
        date: '2021/12/13',
        pic: 'cba-first-stage',
        url: 'cba/21-22-cba-first-stage-summary.html',
    },
    {
        name: '世界杯预选赛名单解析分析报告',
        msg: '中国男篮 VS 日本男篮',
        date: '2021/11/26',
        pic: 'world-cup',
        routeName: 'world-cup',
    },
    {
        name: '世界杯预选赛名单解析',
        msg: '中国男篮 VS 日本男篮',
        date: '2021/11/26',
        pic: 'world-cup-player-comment',
        routeName: 'world-cup-player-comment',
    },
    {
        name: '奥运会 3v3 男篮及女篮分析报告',
        msg: '中国男篮 VS 塞尔维亚男篮 中国女篮 VS 俄罗斯女篮',
        date: '2021/10/29',
        pic: 'olympic-3v3-men',
        routeName: '3v3-home',
    },
    {
        name: '奥运会 5v5 女篮分析报告',
        msg: '中国女篮 VS 塞尔维亚女篮',
        date: '2021/11/1',
        pic: 'olympic-5v5-women',
        routeName: '5v5-home',
    },
    {
        name: '奥运会球员球队分析报告',
        msg: '男篮5v5，女篮5v5，男篮3v3 ，女篮3v3',
        date: '2021/8/26',
        pic: 'olympic',
        routeName: 'olympic',
    },
    {
        name: '东京奥运篮球数据分析总结报告',
        msg: '三人男女篮数据',
        date: '2021/8/18',
        pic: 'olympic-report-1',
        url: 'olympic-report/report-3.html',
    },
    {
        name: '东京奥运篮球数据分析总结报告',
        msg: '五人男女篮球员数据',
        date: '2021/8/18',
        pic: 'olympic-report-2',
        url: 'olympic-report/report-2.html',
    },
    {
        name: '东京奥运篮球数据分析总结报告',
        msg: '五人男女篮赛事&球队数据',
        date: '2021/8/18',
        pic: 'olympic-report-3',
        url: 'olympic-report/report-1.html',
    },
]

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_input_search, {
        id: "inputSearch",
        class: "input",
        size: "large",
        "enter-button": "",
        value: inputKey.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((inputKey).value = $event)),
        onSearch: onSearch,
        placeholder: "请输入你要查找的内容"
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchList.value.length ? searchList.value : dataList, (i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i.name,
          id: i.name,
          class: "item",
          onClick: ($event: any) => (navToDetail(i))
        }, [
          _createElementVNode("img", {
            class: "img",
            src: `assets/${i.pic}.webp`,
            alt: ""
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, _toDisplayString(i.name), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(i.msg), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(i.date), 1)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ], 64))
}
}

})